import React, { useState, useContext } from 'react';

import {
    PortalContext,
    menuHelper,
    App365Container
} from '@portal/arq-portal-core';
import {
    makeStyles,
    Box,
    Tabs,
    Tab
} from '@material-ui/core';

import TabPanel from './TabPanel';

const useStyles = makeStyles({
    tabs: {
        flexGrow: 1,
        '& > .MuiTabs-fixed > .MuiTabs-indicator': {
            backgroundColor: 'inherit',
            width: 'inherit',
            '&:before': {
                content: '">"',
                marginLeft: 285,
                fontSize: 28,
                color: '#dc0028',
                position: 'relative',
                top: 18,
                fontWeight: 'bold',
                fontFamily: 'monospace'
            }
        }
    },
    tab: {
        backgroundColor: '#FFFFFF',
        marginBottom: 10,
        opacity: 1,
        color: '#606060',
        '&.Mui-selected' : {
            backgroundColor: '#dc0028',
            color: '#FFFFFF'
        }
    }
});

interface AsesoresFinancierosProps {
    menuOption?: string;
}

export const AsesoresFinancieros = (props: AsesoresFinancierosProps) => {

    const clases = useStyles();
    const [value, setValue] = useState(0);
    const { menu } = useContext(PortalContext);
    const { getMenuOption } = menuHelper;
    const menuOption = getMenuOption(menu, props.menuOption ? props.menuOption : '/portales/asesorfinanciero');

    // @ts-ignore
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ flexGrow: 1, display: 'flex', margin: '2rem' }}>
            <Tabs
                orientation="vertical"
                value={value}
                onChange={handleChange}
                aria-label="Tabs Asesores Financieros"
                className={clases.tabs}
            >
                {menuOption?.enlaces?.map((item: any) =>
                    <Tab key={item.id} label={item.titulo} icon={<i className={item.icono} />} className={clases.tab} />
                )}
            </Tabs>
            {menuOption?.enlaces?.map((item: any, index: number) =>
                <TabPanel key={item.id} value={value} index={index} >
                    <App365Container menuOption={{...item, tipo: 'GCOAPP365', urlApp: 'ARQ.Portal.Homes.FE.AsesoresFinancieros/', titulo: menuOption.titulo}} />
                </TabPanel>
            )}
        </Box>
    );
};
